<template>
  <doughnut
    :chart-data="data"
    :chart-options="options"
    :plugins="plugins"
  />
</template>

<script>
import Chart from 'chart.js/auto';
import {Doughnut} from "vue-chartjs/legacy";

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  }
}
</script>